// Desktop gallery thumbnails: each button (data-thumb-index) scrolls the main gallery track
// (data-target = track id) to its slide; the thumbnail for the visible slide gets aria-current.
class SGalleryThumbs extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.track = document.getElementById(this.dataset.target || '');
    if (!this.track) return;
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.buttons = [...this.querySelectorAll('[data-thumb-index]')];

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-thumb-index]');
      if (!button) return;
      const slide = this.track.children[Number(button.dataset.thumbIndex)];
      if (slide) this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }, { signal });

    let frame = 0;
    this.track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => this.#sync());
    }, { passive: true, signal });
    this.#sync();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #sync() {
    const width = this.track.clientWidth || 1;
    const index = Math.round(this.track.scrollLeft / width);
    this.buttons.forEach((button, i) => {
      if (i === Math.abs(index)) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
  }
}

if (!customElements.get('s-gallery-thumbs')) customElements.define('s-gallery-thumbs', SGalleryThumbs);
